import { Form, Switch, Input, Typography } from 'antd'
import PropTypes from 'prop-types'
import React, { useState } from 'react'
import { ConfigCard } from './styles'

const { Text } = Typography
const FormItem = Form.Item

const ExternalUser = ({ externalUser }) => {
	const [isExternalUserEnabled, setIsExternalUserEnabled] = useState(
		externalUser.enabled ?? false
	)

	const handleSwitchChange = (enabled) => {
		setIsExternalUserEnabled(enabled)
	}

	return (
		<ConfigCard
			title="Usuário Externo"
			extra={
				<FormItem
					name="externalUserEnabled"
					valuePropName="checked"
					initialValue={externalUser.enabled}>
					<Switch
						checked={isExternalUserEnabled}
						onChange={handleSwitchChange}
					/>
				</FormItem>
			}>
			{isExternalUserEnabled ? (
				<>
					<Text style={{ marginBottom: '10px', display: 'block' }}>
						Use esta configuração para informar qual variável vai conter o nome
						do usuário externo.
					</Text>
					<FormItem
						label="Digite o nome da variável"
						name="externalUserVar"
						initialValue={externalUser.variable}
						rules={[
							{
								required: true,
								message:
									'Por favor informe o nome da variável do usuario externo.',
							},
						]}>
						<Input placeholder="Nome da variável" />
					</FormItem>
				</>
			) : (
				<Text>
					Use esta configuração para informar qual variável vai conter o nome do
					usuário externo.
				</Text>
			)}
		</ConfigCard>
	)
}

ExternalUser.propTypes = {
	externalUser: PropTypes.shape({
		enabled: PropTypes.bool.isRequired,
		variable: PropTypes.string,
	}),
}

export default ExternalUser
